import React, { useEffect, useState } from 'react'
import { Box, LinearProgress, SxProps, Typography, MenuItem, Snackbar, Alert } from '@mui/material'
import { modifyPayment } from "../../service/payApi"
import PaymentIcon from '@mui/icons-material/Payment'

export default function ChangePayment() {
  const [busy, setBusy] = useState(false)
  const [showErr, setShowErr] = useState(false)

  async function onPayment() {
    setBusy(true)
    setShowErr(false)
    const url = await modifyPayment()
    if (url instanceof Error)
      setShowErr(true)
    else
      window.location.href = url
    setBusy(false)
  }

  return (
    <>
      <MenuItem onClick={onPayment}>
        <PaymentIcon sx={{ color: 'gray', marginRight: "15px" }} />Change Payment Method
      </MenuItem>

      {busy && <LinearProgress />}

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={showErr} autoHideDuration={3000}
        onClose={() => setShowErr(false)}
      >
        <Alert variant="filled" severity="error" >
          Something went wrong, try again. if issue persists, contact support@finmate.ai
        </Alert>
      </Snackbar>

    </ >
  )
}
